// `MAT_DATE_FORMATS` marker for datepicker inputs: `CustomDateAdapter` reads and writes YYYY-MM-DD, or
// DD-MM-YYYY in day-first languages, instead of the browser's `Intl` / `Date.parse` format. The
// `datepicker.dateInputHint` translations spell out the same order for each language.
export const DATE_INPUT_FORMAT = 'essDateInput';
